import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 是否显示返回按钮
      isBtn: true,
      // 默认关闭
      dialogVisible: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        prequalificationId: null, // 资格预审结果表主键
        announcementId: null, // 招标公告编号
        registrationId: null, // 招标登记编号
        tenderPrjName: null, // 招标项目名称
        prequalificationStartDate: null, // 预审公示开始时间
        prequalificationEndDate: null, // 预审公示结束时间
        drawTime: null, // 随机抽签时间
        drawAddress: null, // 随机抽签地点
        publishFlag: null, // 是否网上公布
        prequalificationCondition: null, // 资格预审情况
        remarks: null, // 备注
        municipalScale: null, // 工程规模指标
        quotaNum: null, // 合格投标人数量
        unitProjectNum: null, // 单位工程数（个）
        reviewAdd: null, // 评审地点
        reviewDate: null, // 评审时间
        prequalificationContent: null, // 评审程序和内容
        state: null, // 状态
        auditState: null, // 核验状态
        reportState: null, // 报告状态
        tenderOpinion: null, // 招标人意见
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
      },
      // 表单错误
      errRules: {

      },
      // 表单配置
      formConfigList: [
        {
          title: "项目信息",
          name: "1",
          icon: "",
          formConfigList: [
            {
              label: "招标项目名称：",
              type: "input",
              value: "tenderPrjName",
              width: "100%",
              disabled: true,
            },
            {
              label: "招标公告编号：",
              type: "input",
              value: "announcementId",
              disabled: true,
            },
            {
              label: "预审公示开始时间：",
              type: "input",
              value: "prequalificationStartDate",
              disabled: true,
            },
          ]
        },
        {
          title: "",
          name: "3",
          icon: "",
          formConfigList: [
            {
              type: "slot",
              slotName: "projectTenderList",
              class: "formList",
            },
          ]
        },
        {
          title: "资格预审信息",
          name: "4",
          icon: "",
          formConfigList: [
            {
              type: "slot",
              slotName: "preList",
              class: "formList",
            },
          ]
        },
        {
          title: "其他",
          name: "5",
          icon: "",
          formConfigList: [
            {
              label: "资格预审情况：",
              value: "prequalificationCondition",
              type: "textarea",
              required: true,
              maxlength: 1300,
              minRows: "3",
              maxRows: "2",
              disabled: true,
              width: "100%;"
            },
            {
              label: "备注：",
              value: "remarks",
              type: "textarea",
              required: true,
              maxlength: 1300,
              minRows: "3",
              maxRows: "2",
              disabled: true,
              width: "100%;"
            },
          ]
        },
      ],
      /*****************************文件下载名单****************************/
      projectTenderLoading: false,  // 列表loading状态
      // 查询表单字段
      projectTenderForm: {
        tenderUnitsName: null, // 投标单位名称
      },
      // 查询表单
      projectTenderFormSearchList: [
        {
          type: "input",
          label: "投标单位名称：",
          value: "tenderUnitsName",
          placeholder: "请输入",
        },
      ],
      // 表格基础数据
      projectTenderTableColumns: [
        {
          label: "投标单位名称",
          slotName: "tenderUnitsName",
          minWidth: "230"
        },
        {
          label: "资格预审申请文件下载",
          prop: "signUpTime",
          minWidth: "200"
        },
        {
          label: "已投标段",
          slotName: "bidSection",
          minWidth: "100"
        },
        {
          label: "预审结果",
          slotName: "isSemifinalist",
          minWidth: "100"
        },
        {
          label: "预审不通过原因",
          prop: "notSemifinalistReason",
          minWidth: "180"
        },
      ],
      // 表格数据
      projectTenderTableData: [],
      /*****************************资格预审信息****************************/
      preLoading: false,  // 列表loading状态
      // 查询表单字段
      preForm: {

      },
      // 表格基础数据
      preTableColumns: [
        {
          label: "标段",
          prop: "section",
          minWidth: "80"
        },
        {
          label: "招标编号",
          prop: "tenderReference",
          minWidth: "200"
        },
        {
          label: "通知书回复天数（天）",
          prop: "noticeReplyDays",
          minWidth: "200"
        },
        {
          label: "通知书发出时间",
          prop: "noticeIssueDate",
          minWidth: "200"
        },
        {
          label: "通知书回复截止时间",
          prop: "noticeReplyEndDate",
          minWidth: "200"
        },
        {
          label: "资格预审结果解释截止时间",
          prop: "preResultExplainEndDate",
          minWidth: "260"
        },
      ],
      // 表格数据
      preTableData: [],
    };
  },
  // 注册组件
  components: {

  },
  // 模板编译完成
  mounted() {

  },
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 查询一览数据
      this.fun_Details();
    },
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/prequalificationBackup/detail", {
        id: this.form.id, // 主键
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 投标下载名单设置
          this.fun_ProjectTenderList();
          // 设置资格预审信息
          this.fun_PrequalificationInfoList();
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 文件下载名单一览
     */
    fun_ProjectTenderList() {
      // 请求，获取结果集
      fun_PostAction("/prequalificationBackup/projectTenderList", {
        ...this.projectTenderForm,
        announcementId: this.form.announcementId,
        prequalificationId: this.form.prequalificationId
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 回显table
          this.projectTenderTableData = data;
          // 遍历
          this.projectTenderTableData.map(item => {
            // 不合格或不入围
            if (item.isSemifinalist === "0" || item.drawResult === "0") {
              // 不入围原因不为空
              if (item.notDrawReason) {
                // 拼接预审结果不合格原因 + 不入围原因
                item.notSemifinalistReason = item.notSemifinalistReason + "," + item.notDrawReason;
              }
              // 赋值显示不通过
              item.isSemifinalist = "0";
            }
            // 非主体单位不为空
            if (item.tenderUnitsNotMainName) {
              // 拼接投标单位名称
              item.tenderUnitsName = item.tenderUnitsName + "、" + item.tenderUnitsNotMainName;
            }
          });
        }
      });
    },
    /**
     * 发送资格预审通知书信息一览
     */
    fun_PrequalificationInfoList() {
      // 请求，获取结果集
      fun_PostAction("/prequalificationBackup/infoList", {
        announcementId: this.form.announcementId,
        prequalificationId: this.form.prequalificationId
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 回显table
          this.preTableData = data;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 关闭页面弹框
      this.dialogVisible = false;
    },
  }
};
